import React, { useEffect, useState } from 'react';
import EnhancedTable from '../../../Components/EnhancedTable';
import EditIcon from '@mui/icons-material/Edit';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import VisibilityIcon from '@mui/icons-material/Visibility';

import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { createApiData, fetchApiData, updateApiData } from '../../../Components/Api';
import { useExcelDownloder } from '@coinsummer/react-xls';
import { useNavigate, useOutletContext, useParams, useSearchParams } from 'react-router-dom';
import formatAmount from '../../../Components/formatAmount';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import CompanyService from '../../../services/bioplus-services/company';
import { useCompany } from '../../../hooks/CompanyContext';
import { useUserContext } from '../../../hooks/UserContext';
import CompanyPicker from '../../../Components/company-picker';
import Paper from '@mui/material/Paper';
import * as InvitationService from '../../../services/bioplus-services/invitation';

const AcceptCompanyInvitation = () => {
  const [loader, setLoader] = useOutletContext();
  const [status, setStatus] = useState();
  const userContext = useUserContext();

  const companyId = userContext?.company?.companyId?.id;
  const { invitationId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [company, setCompany] = useState();
  const invitationQuery = useQuery(['invitation', invitationId], () =>
    InvitationService.get(invitationId)
  );
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (payload) => {
      setLoader(true);
      return InvitationService.acceptCompanyInvitation(payload);
    },
    onSuccess: () => {
      setLoader(false);
      queryClient.invalidateQueries('companies');
      setStatus('Invitation Accepted');
    },
  });
  useEffect(() => {}, []);

  const invitationCode = searchParams.get('code');

  const handleCompanyChange = (c) => {
    setCompany(c);
  };

  const targetCompany = invitationQuery?.data?.targetCompany;
  const companyName = invitationQuery?.data?.companyName;

  const handleAccept = () => {
    const payload = {
      companyId: company,
      invitationId: invitationId,
      invitationCode: invitationCode,
    };

    mutation.mutate(payload);
  };

  if (mutation.isError) {
    setLoader(false);
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '99%' }}>
        <Typography variant="h5" id="tableTitle" component="div" padding={1}>
          Join Entity
        </Typography>
      </div>
      <div style={{ display: 'flex' }} />
      <Paper>
        {mutation.error && (
          <Box p={2}>
            <Stack>
              <div>
                ERROR: Unable to complete entity link. {mutation?.error?.response?.data?.message}
              </div>
            </Stack>
          </Box>
        )}
        {!status && !mutation.isError && (
          <Box p={2}>
            <Stack>
              <div>
                Your entity (<strong>{targetCompany}</strong>) has been invited to join{' '}
                <strong>{companyName}</strong>.
              </div>
              <Box mt={2} mb={2}>
                Select the entity and click the accept button to join
              </Box>
              <CompanyPicker onChange={handleCompanyChange} />
              <Box mt={5}>
                <Button variant={'contained'} onClick={handleAccept}>
                  Accept
                </Button>
              </Box>
            </Stack>
          </Box>
        )}
        {!!status && (
          <Box p={2}>
            <Stack>
              <div>You are now linked to entity ${companyName}.</div>
            </Stack>
          </Box>
        )}
      </Paper>
    </>
  );
};

export default AcceptCompanyInvitation;
